import React, { FC, PropsWithChildren }from 'react';
import Collapse, { CollapseProps } from 'antd/lib/collapse';

import cn from 'classnames';

import style from './style.module.scss';

export enum FilterCollapseKeys {
  ADDITIONAL_FILTERS = 'additional_filters',
}

interface CarFilterCollapseProps extends PropsWithChildren<Omit<CollapseProps, 'expandIcon' | 'expandIconPosition'>> {
  // eslint-disable-next-line react/require-default-props
  defaultActiveKey?: FilterCollapseKeys | FilterCollapseKeys[]
};

const CarFilterCollapse: FC<CarFilterCollapseProps> = ({
  children,
  className,
  defaultActiveKey,
  ...props 
}: CarFilterCollapseProps) => {

  return (
    <Collapse
      className={cn(style.filterCollapse, className)}
      defaultActiveKey={defaultActiveKey}
      expandIconPosition="left"
      expandIcon={({ isActive }) => (
        <div
          className={cn(style.toggleIcon, {
            [style.toggleIconUp]: isActive,
          })}
        />
      )}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {children}
    </Collapse>
  );
};

export default CarFilterCollapse;
